import { useAppModalsContext } from "../context/AppModalsContext";

/**
 * Hook to manage all modal states in the app.
 * Uses shared context so modals work from any component (e.g. Sidebar, AppHeader, screens).
 */
export const useAppModals = () => useAppModalsContext();
